/** @file The plain compile stages (no caching): the table compileDoc runs. */
import { compileAnimations } from './compileAnimations';
import { compileAttachments } from './compileAttachments';
import { compileBones } from './compileBones';
import { compileDirections } from './compileDirections';
import { compileSkinning } from './compileSkinning';
import { compileSockets } from './compileSockets';
import type { CompileStages } from './compileStages';
import { compileUpdateOrder } from './compileUpdateOrder';

/** Stage table that calls every compile stage directly. */
export const DIRECT_STAGES: CompileStages = {
  bones: compileBones,
  updateOrder: compileUpdateOrder,
  attachments: compileAttachments,
  skinning: compileSkinning,
  sockets: compileSockets,
  animations: compileAnimations,
  directions: compileDirections,
};
